import React from "react"
import {Col, Row} from "react-bootstrap"
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import AvatarSkeleton from "../../../components/skeletons/AvatarSkeleton";

export default function MyProfileSkeleton() {
    return(
        <div className={'my-profile'}>
            <Row>
                <Col lg={12} xl={10}>
                    <h2>  <HeadingSkeleton height={15} maxWidth={250}/>
                        <span>
                            <HeadingSkeleton height={20} maxWidth={50}/>
                        </span>
                    </h2>
                </Col>
                <Col md={12} lg={6} xl={5} >
                    <div className={'my-profile-box'}>
                        <div className={'profile-box-sec'}>
                            <div className={'profile-box'}>
                                <div className={'profile-avatar'}>
                                    <AvatarSkeleton avatarShape={'circle'} height={90} width={90}/>
                                </div>
                                <div className={'profile-content'}>
                                    <h4><HeadingSkeleton height={20} maxWidth={150}/></h4>
                                    <HeadingSkeleton height={20} maxWidth={60}/>
                                </div>
                            </div>
                            <div className={'my-profile-box-list'}>
                                <ul>
                                    <li>
                                        <div className={'my-profile-box-list-card'}>
                                            <div className={'icon'}>
                                                <AvatarSkeleton avatarShape={'circle'} height={30} width={30}/>
                                            </div>
                                            <div className={'content'}>
                                                <p><HeadingSkeleton height={12} maxWidth={100}/></p>
                                                <h5><HeadingSkeleton height={12} maxWidth={300}/></h5>
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className={'my-profile-box-list-card'}>
                                            <div className={'icon'}>
                                                <AvatarSkeleton avatarShape={'circle'} height={30} width={30}/>
                                            </div>
                                            <div className={'content'}>
                                                <p><HeadingSkeleton height={12} maxWidth={100}/></p>
                                                <h5><HeadingSkeleton height={12} maxWidth={300}/></h5>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className={'my-profile-box-list-card'}>
                                            <div className={'icon'}>
                                                <AvatarSkeleton avatarShape={'circle'} height={30} width={30}/>
                                            </div>
                                            <div className={'content'}>
                                                <p><HeadingSkeleton height={12} maxWidth={100}/></p>
                                                <h5><HeadingSkeleton height={12} maxWidth={300}/></h5>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className={'my-profile-box-2'}>
                                <h4><HeadingSkeleton height={10} maxWidth={100}/></h4>
                                <div className={'content'}>
                                    <HeadingSkeleton height={20} maxWidth={100}/>
                                    <span><HeadingSkeleton height={10} maxWidth={100}/></span>
                                </div>
                            </div>
                            <div className={'my-profile-box-2'}>
                                <h4><HeadingSkeleton height={10} maxWidth={100}/></h4>
                                <div className={'content'}>
                                    <HeadingSkeleton height={15} maxWidth={100}/>
                                    <p><HeadingSkeleton height={10} maxWidth={100}/></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col className={'mt-5 mt-lg-0'} md={12} lg={6} xl={5}>
                    <div className={'my-profile-box'}>
                        <div className={'profile-box-sec'}>
                            <h3><HeadingSkeleton height={18} maxWidth={200}/></h3>
                            <div className={'my-profile-box-list'}>
                                <ul>
                                    <li>
                                        <div className={'my-profile-box-list-card'}>
                                            <div className={'icon'}>
                                                <AvatarSkeleton avatarShape={'circle'} height={30} width={30}/>
                                            </div>
                                            <div className={'content'}>
                                                <p><HeadingSkeleton height={12} maxWidth={100}/></p>
                                                <h5><HeadingSkeleton height={12} maxWidth={300}/></h5>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className={'my-profile-box-list-card'}>
                                            <div className={'icon'}>
                                                <AvatarSkeleton avatarShape={'circle'} height={30} width={30}/>
                                            </div>
                                            <div className={'content'}>
                                                <p><HeadingSkeleton height={12} maxWidth={100}/></p>
                                                <h5><HeadingSkeleton height={12} maxWidth={300}/></h5>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className={'my-profile-box-list-card'}>
                                            <div className={'icon'}>
                                                <AvatarSkeleton avatarShape={'circle'} height={30} width={30}/>
                                            </div>
                                            <div className={'content'}>
                                                <p><HeadingSkeleton height={12} maxWidth={100}/></p>
                                                <h5><HeadingSkeleton height={12} maxWidth={300}/></h5>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className={'my-profile-box-list-card'}>
                                            <div className={'icon'}>
                                                <AvatarSkeleton avatarShape={'circle'} height={30} width={30}/>
                                            </div>
                                            <div className={'content'}>
                                                <p><HeadingSkeleton height={12} maxWidth={100}/></p>
                                                <h5><HeadingSkeleton height={12} maxWidth={300}/></h5>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className={'my-profile-box-list-card'}>
                                            <div className={'icon'}>
                                                <AvatarSkeleton avatarShape={'circle'} height={30} width={30}/>
                                            </div>
                                            <div className={'content'}>
                                                <p><HeadingSkeleton height={12} maxWidth={100}/></p>
                                                <h5><HeadingSkeleton height={12} maxWidth={300}/></h5>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}